export default {
    after: (field, [target]) => `${field} мора да биде поспоред ${target}.`,
    alpha_dash: (field) => `${field} може да содржи алфа-нумерички знаци, како и црти и доцници.`,
    alpha_num: (field) => `${field} може да содржи само алфа-нумерички знаци.`,
    alpha_spaces: (field) => `${field} може да содржи само алфабетски знаци како и празни места.`,
    alpha: (field) => `${field} може да содржи само алфабетски знаци.`,
    before: (field, [target]) => `${field} мора да биде пред ${target}.`,
    between: (field, [min, max]) => `${field} мора да биде помеѓу ${min} и ${max}.`,
    confirmed: (field) => `Потврдата на ${field} не се совпаѓа.`,
    credit_card: (field) => `${field} не е валидна кредитна картичка.`,
    date_between: (field, [min, max]) => `${field} мора да биде помеѓу ${min} и ${max}.`,
    date_format: (field, [format]) => `${field} мора да биде во формат ${format}.`,
    decimal: (field, [decimals] = ['*']) => `${field} мора да биде нумеричко и може да содржи ${decimals === '*' ? '' : decimals} децимални точки.`,
    digits: (field, [length]) => `${field} мора да биде нумеричко и точно да содржи ${length} цифри.`,
    dimensions: (field, [width, height]) => `${field} мора да биде ${width} пиксели по широчина и ${height} пиксели по висина.`,
    email: (field) => `${field} мора да биде валидна е-пошта.`,
    ext: (field) => `${field} мора да биде валидна датотека.`,
    image: (field) => `${field} мора да биде слика.`,
    in: (field) => `${field} мора да биде валидна вредност.`,
    ip: (field) => `${field} мора да биде валидна IP адреса.`,
    max: (field, [length]) => `${field} не може да биде подолго од ${length} знаци.`,
    max_value: (field, [max]) => `${field} мора да биде ${max} или помалку.`,
    mimes: (field) => `${field} мора да има валиден тип на датотека.`,
    min: (field, [length]) => `${field} мора да биде барем ${length} знаци.`,
    min_value: (field, [min]) => `${field} мора да биде ${min} или повеќе.`,
    not_in: (field) => `${field} мора да биде валидна вредност.`,
    numeric: (field) => `${field} може да содржи само нумерички знаци.`,
    regex: (field) => `Форматот на ${field} не е валиден.`,
    required: (field) => `${field} е задолжително.`,
    size: (field, [size]) => `${field} мора да биде помалку од ${size} КБ.`,
    url: (field) => `${field} не е валидна URL адреса.`,
};
